/* Version: 3.5.155 */
'use client';
import { SIDES } from '../constants.js';

var TOOLTIP_SIDES = {
  BOTTOM: SIDES.BOTTOM,
  BOTTOM_LEFT: SIDES.BOTTOM_LEFT,
  BOTTOM_RIGHT: SIDES.BOTTOM_RIGHT,
  TOP: SIDES.TOP,
  TOP_LEFT: SIDES.TOP_LEFT,
  TOP_RIGHT: SIDES.TOP_RIGHT,
  RIGHT: SIDES.RIGHT // Connected DS only
};
var TOOLTIP_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var DEFAULT_STATE = {
  showTooltip: false,
  deferredClose: false,
  side: undefined
};
var TOOLTIP_ACTIONS = {
  HOVER_START: 'hoverStart',
  HOVER_END: 'hoverEnd',
  FOCUS_START: 'focusStart',
  FOCUS_END: 'focusEnd',
  CLICK_TOGGLE: 'clickToggle',
  CLICK_CLOSE: 'clickClose',
  CLICK_OUTSIDE: 'clickOutside',
  PRESS_ESCAPE: 'pressEscape',
  DEFERRED_CLOSE: 'deferredClose'
};

export { DEFAULT_STATE, TOOLTIP_ACTIONS, TOOLTIP_SIDES, TOOLTIP_VARIANT };
